import { IMPRESSION_TRACKER_PLACEHOLDER } from "./ImpressionTrackerTemplate";
import { JAVASCRIPT_TAG_PLACEHOLDER } from "./javscriptTag";

export const srcRegexGet = /<img src="(.*?)"/s;

type InterstitialTemlplateType = (opts: { src: string }) => string;
const interstitialTemlplate: InterstitialTemlplateType = ({ src }) =>
  `<!DOCTYPE html><html lang='en'><head><meta charset=utf-8>
  <meta name="viewport" content="height=device-height, initial-scale=1, minimal-ui, minimum-scale=1" /><style>html,body{height: 100%; margin:0;padding:0;overflow:hidden;font-family:Arial;font-size:12px;color:#fff;background:#000000;-webkit-text-size-adjust:none;-webkit-tap-highlight-color:transparent}#loading{color:#fff;background:#222;align-content: center;background: #000;opacity: 1;z-index:10;width: 100%;height: 100%;line-height: 100%;text-align: center;display: inline-block;font-size: 48px;padding-top: 5%}img {
      max-height: 100%; object-fit: contain; object-position: center; width: 100%; }#advert{ height: 100%; display: flex;}</style></head><body>
<div id="advert"><img src="${src}" /></div>
${IMPRESSION_TRACKER_PLACEHOLDER}
${JAVASCRIPT_TAG_PLACEHOLDER}
<script>
document.getElementById("advert").addEventListener('click', function(event) { doClick(); }, false);
function isVungle() { var exchange = "\${request.exchange}"; return exchange == "vungle"; }
function isApplovin() { var exchange = "\${request.exchange}"; return exchange == "applovin"; }
function isChartboost() { var exchange = "\${request.exchange}"; return exchange == "chartboost"; }
function doClick() {
  var url = "\${click.tracker.url}";
  var redirect = "\${click.through.url}";
  var xhr = new XMLHttpRequest();
  xhr.onload = function (e) {
    if (isVungle()) {
      mraid.open(redirect);
    } else if (!isApplovin() && typeof mraid !== 'undefined' && mraid.open) {
      mraid.open(redirect);
    } else if (isChartboost()) {
      window.open(redirect, '_blank');
    } else {
      window.location=redirect;
    }
  };
  xhr.onerror = function (e) {
    if (isVungle()) {
      mraid.open(redirect);
    } else if (!isApplovin() && typeof mraid !== 'undefined' && mraid.open) {
      mraid.open(redirect);
    } else if (isChartboost()) {
      window.open(redirect, '_blank');
    } else {
      window.location=redirect;
    }
  };
  xhr.timeout = 2000;
  xhr.open("GET", url, true);
  xhr.send();
}
</script></body></html>`;
export const isInterstitialByBannerSize = (bannerSize: string | null) => {
  // bannerSize example: 300x250
  if (!bannerSize) return false;
  const [widthS, heightS] = bannerSize && bannerSize.split("x");
  const width = parseInt(widthS || "");
  const height = parseInt(heightS || "");

  return (
    Number.isInteger(width) &&
    Number.isInteger(height) &&
    width > 300 &&
    height > 100
  );
};
export default interstitialTemlplate;
